import * as React from 'react';
import { NoteCard, useNote } from './note';
export const Pane = ({ subject, context }) => {
    const store = context.session.store;
    const note = useNote(subject, store);
    return React.createElement(NoteCard, { ...note });
};
//# sourceMappingURL=Pane.js.map